import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultSubtenantDeviceInfo } from '../interfaces/DeviceIf'
import { useAuth } from './useAuth'

interface C216SubtenantDeviceGetProps {
  execSubtenantDeviceGet: (tenant: string) => Promise<ResultSubtenantDeviceInfo>
  loading: loadStatus
}

// C213 テナント配下デバイス取得API呼出
export const useC216SubtenantDeviceGet = (): C216SubtenantDeviceGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execSubtenantDeviceGet = async (tenant: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(
        `${baseUrl}${stage}${apiUrl.tenantsPath}${tenant}${apiUrl.subtenantDevicesPath}`,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }

      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execSubtenantDeviceGet, loading }
}
